import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ValidaCfopService {
    constructor(private http: HttpClient) { }

    validateCfop(cfop: number) {
        return this.http.get(`${environment.apiUrl}/api/Cfop/${cfop}`);
    }
}
